import axios from "@/api/axiosInstance";
import { FetchEmployeeDirectoryProfileResponse } from "./types";

export const fetchEmployeeDirectoryProfile = async (
  uuid: string,
): Promise<FetchEmployeeDirectoryProfileResponse> => {
  const response = await axios.get<FetchEmployeeDirectoryProfileResponse>(
    `/api/private/employee-directory/profiles/${uuid}`,
  );
  return response.data;
};
